import _ from 'lodash';
export const remToPx = rem => {
  return rem * 16;
};
export const pxToRem = px => {
  return px / 16;
};
export const checkedImageUrl = color => {
  return `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23${_.replace(color, '#', '')}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;`;
};